<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title"><i class="fa fa-edit me-2"></i> Edit Message</h4>
      </div>
      <div class="modal-body">

        <div class="mb-3">
          <label class="form-label">Predefined (optional)</label>
          <select class="form-select" [(ngModel)]="selectedPredefinedId" (ngModelChange)="onPredefinedChange()">
            <option [ngValue]="0">— None —</option>
            @for (p of predefinedList; track p.newsPredefinedId) {
              <option [ngValue]="p.newsPredefinedId">{{ p.name }}</option>
            }
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label">Title</label>
          <input type="text" class="form-control" [(ngModel)]="title" (ngModelChange)="onFieldChanged()" placeholder="Title" />
        </div>

        <div class="mb-3">
          <label class="form-label">Summary</label>
          <textarea class="form-control" [(ngModel)]="summary" (ngModelChange)="onFieldChanged()" rows="2" placeholder="Summary"></textarea>
        </div>

        <div class="mb-3">
          <label class="form-label">Content</label>
          <textarea class="form-control" [(ngModel)]="content" (ngModelChange)="onFieldChanged()" rows="4" placeholder="Content"></textarea>
        </div>

        <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" [(ngModel)]="isRate" id="isRateUserEdit">
          <label class="form-check-label" for="isRateUserEdit">Rate</label>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.hide()" [disabled]="isLoading">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="isLoading">
          @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Save
        </button>
      </div>
    </div>
  </div>
</div>
